import React from "react";
import { connect, useSelector } from "react-redux";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import payment_success from "../../../../assets/svgs/payment_success.svg";
import payment_failed from "../../../../assets/svgs/payment_failed.svg";
import Button from "../../Button/Button";
import { APP_NAME } from "../../../../lib/constants/globalConstant";
import { coinPaymentModalStyles as styles } from "./coinsPaymentModalStatusModalStyles.tailwind.js";
import { PAYMENT_STATUS } from "../../../../lib/constants/globalConstant";
import { getMyCart } from "../../../../redux/slices/cartSlice.js";
import { useNavigate } from "react-router-dom";
import routeConstant from "../../../../lib/constants/routeConstant.js";

const CoinPaymentStatusModal = ({
    isOpen,
    onClose,
    status,
    getCart
}) => {
    const navigate = useNavigate();
    const { checkoutCoinsApiData } = useSelector((state) => state.cart);
    const { currentSeason } = useSelector(state => state.seasons);

    // const pointOrCoinText = isTransactionCoins() ? "coins" : "points";

    const successData = {
        Heading: "Thank you",
        SubHeading: `Enjoy the Game!`,
        // Message: `A copy of your receipt has been sent to your email address ${checkoutCoinsApiData?.points}. Now Sit Back, Earn Coins, Watch Games, and Get Exclusive Rewards!`,
        // Message:checkoutCoinsApiData?.awardedPoints ? `You have been awarded a bonus of ${checkoutCoinsApiData?.awardedPoints} points for your token purchase` : `Your token purchase was successfully completed. Thank you!`,
    };

    const errorData = {
        Heading: "Purchase Failed!",
        // SubHeading: "Something went wrong",
        Message: "Your token purchase was not completed. Please try again." ,
    };

    const data = status === PAYMENT_STATUS.SUCCEDED ? successData : errorData;
    const image = status === PAYMENT_STATUS.SUCCEDED ? payment_success : payment_failed;

    const handleOnClose = () => {
        onClose();
    
        if (status === PAYMENT_STATUS.SUCCEDED) {
            getCart ({seasonId: currentSeason?._id});
            navigate(routeConstant.MY_ACCOUNT_PAGE);
        } else {
            getCart ({seasonId: currentSeason?._id});
            navigate(routeConstant.CART_PAGE);
        }
    };

    return (
        <Modal
            open={isOpen} // Use the isOpen prop to control the modal's visibility
            onClose={() => { }} // Prevent closing when clicking outside
            disableAutoFocus
        >
            <div className={styles.container}>
                {/* close button */}
                <button onClick={handleOnClose}>
                    <CloseIcon
                        sx={{
                            position: "absolute",
                            top: 10,
                            right: 10,
                            cursor: "pointer",
                            fontSize: "16px",
                        }}
                    />
                </button>

                {/* main-content */}
                <div className={styles.innerContainer}>
                    {/* center-icon */}
                    <div
                        className={`${styles.doneIcon} ${status === PAYMENT_STATUS.SUCCEDED ? "bg-[#E2FEEE]" : " w-[100%]"
                            } `}
                    >
                        <img src={image} alt="Payment Message" className={`${status === PAYMENT_STATUS.SUCCEDED ? "max-[30px]" : "max-w-[50px] w-[100%]"}`} />
                    </div>

                    {/* texts */}
                    <div
                        className={`${status === PAYMENT_STATUS.SUCCEDED
                            ? styles.thankYouText
                            : styles.thankYouTextError
                            }`}
                    >
                        {data.Heading}
                        <div
                            className={`${status === PAYMENT_STATUS.SUCCEDED
                                ? styles.thankYouMessage
                                : styles.thankYouMessageError
                                }`}
                        >
                            {data.SubHeading}
                        </div>
                    </div>
                    <div className={styles.message}>{data.Message}</div>

                    {/* close button */}
                    <Button variant="primary" onClick={handleOnClose}>
                        {status === PAYMENT_STATUS.SUCCEDED ? "Close" : "Retry"}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

const mapDispatchToProps = (dispatch) => ({
     getCart: (data) => dispatch(getMyCart(data)),
});

export default connect(null, mapDispatchToProps)(CoinPaymentStatusModal);
